import React from "react";
import BannerCvTranslationServices from "./Banner";
import SecondCvTranslationServices from "./SecondCvTranslationServices";

function CvTranslationServices() {
  return (
    <>
      <BannerCvTranslationServices />
      <SecondCvTranslationServices />
    </>
  );
}

export default CvTranslationServices;
